import { render, staticRenderFns } from "./pricetotal.vue?vue&type=template&id=581947aa&"
import script from "./pricetotal.vue?vue&type=script&lang=js&"
export * from "./pricetotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581947aa')) {
      api.createRecord('581947aa', component.options)
    } else {
      api.reload('581947aa', component.options)
    }
    module.hot.accept("./pricetotal.vue?vue&type=template&id=581947aa&", function () {
      api.rerender('581947aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ASY7YVnoZQBa/JS/comp/pricetotal.vue"
export default component.exports